import React, { useContext, useRef } from 'react';
import { businessContext } from '../../../UseContext/BusinessContext';
import Modal from 'react-bootstrap/Modal';
import { AwsFileUrl } from '../../../../../config';
import Slider from 'react-slick';
import toast from 'react-hot-toast';


const EditServicePopup = () => {

  const {
    showEditServicePopup, setShowEditServicePopup,
    service, setService,
    updateService,
    serviceImages, setServiceImages,
    deleteServiceImage,
  } = useContext(businessContext);


  const fileInputRef = useRef(null);

  // handle click
  const handleDivClick = () => {
    fileInputRef.current.click();
  };

  // handle file change
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    if((serviceImages.length + service.images.length + files.length) <= 5) {
      setServiceImages((prevImages) => [...files, ...prevImages]);
    } else {
      toast.error(`You can only select 5 images`);
    };
  };
  
  // handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setService((prevService) => ({
      ...prevService,
      [name]: value,
    }));
  };

  // remove service image 
  const removeProductImage = (indexToRemove) => {
    setServiceImages((prevImages) =>
      prevImages.filter((_, index) => index !== indexToRemove)
    );
  };

  // handle popup close
  const handlePopupClose = () => {
    setShowEditServicePopup(false);

    setServiceImages([]);

    setService({
      images: [],
      title: '',
      description: '',
      price: '',
      number: '',
    });
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1, 
    slidesToScroll: 1, 
    arrows: false, 
  };

  return (
    <>
      <Modal show={showEditServicePopup} onHide={handlePopupClose} keyboard={false} className="create-post" backdrop="static" centered>
        <Modal.Header closeButton>&nbsp;</Modal.Header>
        <Modal.Body>
          <h4 className='text-center mb-4'>Edit Service</h4>

          {/* Images */}
          <div className='mb-3'>
            {/* Add */}
            <>
              {
                (serviceImages.length + service.images.length) < 5
                &&
                <div className='p-1 bg-secondary-subtle rounded-circle d-inline-block mb-2 pt-0' onClick={handleDivClick}>
                  <img src="/images/business/icons/add-circle.svg" style={{ height: '20px' }} alt="add" />

                  <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} multiple />
                </div>
              }
            </>

            {
              <Slider className="service-images-slider" {...settings}>
                {/* Local Images */}
                {
                  serviceImages && serviceImages.length > 0 
                  &&
                  serviceImages.map((image, index) => (
                    <div className='position-relative' key={index}>
                      <div className='border rounded-3'>
                        <img src={URL.createObjectURL(image)} className='rounded-3 object-fit-contain' style={{ height: "300px", width: "100%" }} alt={`Product ${index}`} />
                      </div>

                      {/* Delete */}
                      <>
                        {
                          (serviceImages.length + service.images.length) > 1
                          &&
                          <div className='position-absolute top-0 end-0 mt-3 me-3 p-1 rounded-3 shadow-sm' style={{ backgroundColor: '#4b4b4b96' }} onClick={() => removeProductImage(index)}>
                            <img src="/images/icons/delete-white.svg" style={{ height: '20px' }} alt="delete" />
                          </div>
                        }
                      </>
                    </div>
                  ))
                }

                {/* Live Images */}
                {
                  service && service.images && service.images.length > 0
                  &&
                  service.images.map((value, index) => (
                    <div className='position-relative' key={index}>
                      <div className='border rounded-3'>
                        <img src={`${AwsFileUrl}${value.image}`} className='rounded-3 object-fit-contain' style={{ height: "300px", width: "100%" }} alt={`Product ${index}`} />
                      </div>

                      {/* Delete */}
                      <>
                        {
                          (service.images.length) > 1
                          &&
                          <div className='position-absolute top-0 end-0 mt-3 me-3 p-1 rounded-3 shadow-sm' style={{ backgroundColor: '#4b4b4b96' }} onClick={() => deleteServiceImage(value)}>
                            <img src="/images/icons/delete-white.svg" style={{ height: '20px' }} alt="delete" />
                          </div>
                        }
                      </>
                    </div>
                  ))
                }
              </Slider>
            }
          </div>

          {/* Title */}
          <small className='text-secondary'>Title</small>
          <input type="text" className='form-control border-0 border-bottom shadow-none mb-4' name='title' value={service.title} onChange={handleInputChange} placeholder='Title...' />

          {/* Description */}
          <small className='text-secondary'>Description</small>
          <textarea class="form-control border-0 border-bottom shadow-none mb-4" name='description' value={service.description} onChange={handleInputChange} placeholder='Description...'></textarea>

          {/* Price */}
          <small className='text-secondary'>Price</small>
          <input type="text" className='form-control border-0 border-bottom shadow-none mb-4' name='price' value={service.price} onChange={handleInputChange} placeholder='Price...' />

          {/* Number */}
          <small className='text-secondary'>Number</small>
          <input type="text" className='form-control border-0 border-bottom shadow-none mb-5' name='number' value={service.number} onChange={handleInputChange} placeholder='Number...' />

          {/* Edit */}
          <div className='text-center'>
            <button type="button" className='btn btn-primary w-50 rounded-pill' onClick={updateService}>Edit</button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default EditServicePopup
